import React from 'react'
import { useResponsive } from '../../../utils/hooks'
import { ScrollView, View } from 'react-native'
import { LogoContainer } from './LogoContainer'
import { styles } from './styles'
import { LayoutProps } from '.'

export const DefaultLayout = React.memo(
  ({
    children,
    showsBackButton = true,
    onBackPress,
    contentWidth,
  }: LayoutProps) => {
    const { sm } = useResponsive()
    return (
      <View style={styles.layoutRootView}>
        <LogoContainer
          showsBackButton={showsBackButton}
          onBackPress={onBackPress}
        />
        <ScrollView
          contentContainerStyle={{
            marginVertical: sm ? 100 : 28,
          }}
        >
          <View style={{ width: contentWidth, alignSelf: 'center' }}>
            {children}
          </View>
        </ScrollView>
      </View>
    )
  },
)
